import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SearchBar from "@/components/base/SearchBar";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/search", label: "搜索", end: false },
  { to: "/about", label: "关于", end: false },
  { to: "/contact", label: "联系", end: false },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);

  const closeAll = () => {
    setMobileOpen(false);
    setCategoryOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:px-6">
        {/* Brand */}
        <Link to="/" onClick={closeAll} className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-extrabold tracking-tight text-foreground-950">禁漫天堂</span>
            <span className="mt-0.5 text-[10px] tracking-wide text-foreground-500">MANGA DOWNLOAD</span>
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.slice(0, 1).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}

          {/* Category dropdown */}
          <div
            className="relative"
            onMouseEnter={() => setCategoryOpen(true)}
            onMouseLeave={() => setCategoryOpen(false)}
          >
            <button
              type="button"
              onClick={() => setCategoryOpen((prev) => !prev)}
              className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
              aria-expanded={categoryOpen}
            >
              分类
              <i className={`ri-arrow-down-s-line transition-transform ${categoryOpen ? "rotate-180" : ""}`} />
            </button>
            {categoryOpen && (
              <div className="absolute left-0 top-full z-50 w-[420px] pt-2">
                <div className="grid grid-cols-2 gap-1 rounded-lg border border-background-200 bg-background-50 p-3 animate-fade-in">
                  {categories.map((category) => (
                    <Link
                      key={category.slug}
                      to={`/category/${category.slug}`}
                      onClick={closeAll}
                      className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
                    >
                      <i className={`${category.icon} text-base text-primary-500`} />
                      {category.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {navItems.slice(1).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Desktop search */}
        <div className="hidden w-56 shrink-0 md:block lg:w-64">
          <SearchBar size="sm" placeholder="搜索漫画…" />
        </div>

        {/* Mobile search + menu */}
        <div className="flex items-center gap-2 md:hidden">
          <Link
            to="/search"
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700"
          >
            <i className="ri-search-line text-lg" />
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMobileOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700"
          >
            <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-2-line"} text-xl`} />
          </button>
        </div>
      </div>

      {/* Mobile panel */}
      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-4 md:hidden">
          <SearchBar size="md" placeholder="搜索漫画标题、作者或类型" />
          <nav className="mt-4 flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={closeAll}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                    isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <p className="mt-4 mb-2 text-xs font-semibold uppercase tracking-wide text-foreground-500">漫画分类</p>
          <div className="grid grid-cols-2 gap-2">
            {categories.map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                onClick={closeAll}
                className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className={`${category.icon} text-base text-primary-500`} />
                {category.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}